import ContactService from '@/api/services/ContactService';
import { LINK_TYPE } from '@/constants/link';
import Contact from '@/classes/v2/Contact';

const retrieveContacts = ({ commit }) => {
  return ContactService.getAllContacts().then(contacts => {
    const currentUserContacts = contacts
      .filter(Contact.isValid)
      .filter(contact => contact.linkType === LINK_TYPE.user);
    const enterpriseContacts = contacts
      .filter(Contact.isValid)
      .filter(contact => contact.linkType === LINK_TYPE.account);

    commit('setCurrentUserContacts', currentUserContacts);
    commit('setEnterpriseContacts', enterpriseContacts);

  }, ContactService.onApiError);
};

const retrieveAvatars = ({ commit }, contacts) => {
  const contactUserIds = contacts
    .filter(c => c.isAzureContact && c.userId && !c.avatar)
    .map(c => {
      return { userId: c.userId };
    });
  if (contactUserIds.length === 0) return;
  return ContactService.getContactAvatars(contactUserIds).then(avatarList => {
    if (avatarList) {
      avatarList.forEach(contact => {
        commit('updateContactAvatar', contact);
      });
    }
  });
};

const addUserContact = ({ commit, rootGetters }, contact) => {
  contact.linkId = rootGetters['user/userLinkId'];
  contact.linkType = LINK_TYPE.user;

  return ContactService.upsertUserContact(contact).then(storedContact => {
    commit('addUserContact', storedContact);
    return storedContact;
  }, ContactService.onApiError);
}

const editUserContact = ({ commit, rootGetters }, contact) => {
  contact.linkId = rootGetters['user/userLinkId'];
  contact.linkType = LINK_TYPE.user;

  return ContactService.upsertUserContact(contact).then(storedContact => {
    commit('editUserContact', storedContact);
    return storedContact;
  }, ContactService.onApiError);
}

const deleteUserContact = ({ commit }, contact) => {
  return ContactService.deleteUserContact(contact.id).then(() => {
    commit('groupsV2/removeContactFromAllGroups', contact, { root: true });
    commit('deleteUserContact', contact.contactId);
  }, ContactService.onApiError);
}

export default {
  addUserContact,
  editUserContact,
  deleteUserContact,
  retrieveAvatars,
  retrieveContacts
};
